import { ComponentProps } from 'react';

export const PersonIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.0078 15.2773C14.6655 15.2773 16.2989 15.7619 17.5205 16.7031L17.5225 16.7041C18.3626 17.3468 18.8729 18.2026 19.1436 19.1162C19.2825 19.5851 19.3724 20.0671 19.4277 20.4355C19.431 20.4574 19.4335 20.479 19.4365 20.5H6.58008C6.58833 20.449 6.59514 20.3955 6.60449 20.3408C6.67528 19.9268 6.77166 19.4541 6.87988 19.1357C7.11133 18.4554 7.66657 17.3314 8.48047 16.7021C9.71227 15.7606 11.351 15.2774 13.0078 15.2773ZM13.002 5.5C14.9972 5.5 16.6559 7.12709 16.7578 9.20312L16.7627 9.40625C16.7512 11.5325 15.1504 13.2198 13.1475 13.2998H12.96C10.8441 13.2374 9.24238 11.5313 9.24219 9.40625C9.24219 7.23457 10.9424 5.50027 13.002 5.5Z"
      stroke="currentColor"
    />
  </svg>
);
